import { render, staticRenderFns } from "./SpreadViewerRoutesOptions.vue?vue&type=template&id=34d83f5e"
import script from "./SpreadViewerRoutesOptions.vue?vue&type=script&lang=js"
export * from "./SpreadViewerRoutesOptions.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/devstark/spreadsimple/spreadsimple-app/main-app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('34d83f5e')) {
      api.createRecord('34d83f5e', component.options)
    } else {
      api.reload('34d83f5e', component.options)
    }
    module.hot.accept("./SpreadViewerRoutesOptions.vue?vue&type=template&id=34d83f5e", function () {
      api.rerender('34d83f5e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/spread-viewer-options/spread-viewer-routes-options/SpreadViewerRoutesOptions.vue"
export default component.exports